import specialNotesReducers from './reducer';
import * as notesActions from './reducer';

export { notesActions };

export default specialNotesReducers;
